import { Tag } from 'nhsuk-react-components';
import './FeedBack.scss';
import featureFlags from '../../services/featureFlags';

function FeedBack() {
  const SURVEY_URL = import.meta.env.VITE_FEATURE_QUALTRICS_SURVEY_URL || '';
  const { surveyFeatureEnabled } = featureFlags;

  if (!surveyFeatureEnabled) {
    return null;
  }

  return (
    <header className="nhsuk-header nhsuk-header--white">
      <div className="nhsuk-width-container nhsuk-header__container nhsuk-u-padding-2 feedback-header-container">
        <Tag color="blue">Beta</Tag>
        <span>
          {' '}
          This is a new service – your
          {' '}
          <a
            href={SURVEY_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open SPI feedback form in new tab"
          >
            feedback (open in new tab)
          </a>
          {' '}
          will help us to improve it.
        </span>
      </div>
    </header>
  );
}

export default FeedBack;
